import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=7a47ddce&scoped=true"
import script from "./alipay.vue?vue&type=script&lang=js"
export * from "./alipay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a47ddce",
  null
  
)

export default component.exports